import { IconButton, type IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type React from "react";
import { getColor } from "./utils";

interface IIconButtonVariant extends IconButtonProps {
  variant?: "elevated" | "filled-disabled" | "border" | "filled" | "outlined";
  href?: string;
  target?: string;
}

export const IconButtonVariant = styled<React.FC<IIconButtonVariant>>(IconButton, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant, size, color, disabled }) => {
  const buttonSize = { size: 24, font: 16 };
  switch (size) {
    case "large":
      buttonSize.size = 32;
      buttonSize.font = 20;
      break;
    case "small":
      buttonSize.size = 20;
      buttonSize.font = 14;
      break;
    case "xs":
      buttonSize.size = 16;
      buttonSize.font = 12;
      break;
  }

  const commonStyle = {
    padding: (buttonSize.size - buttonSize.font) / 2,
    width: buttonSize.size,
    height: buttonSize.size,
    minHeight: buttonSize.size,
    backgroundColor: getColor(theme.palette, color, "main", "white"),
    "& .MuiSvgIcon-root": {
      fontSize: buttonSize.font,
    },
    ...(!disabled && {
      "&:hover": {
        backgroundColor: getColor(theme.palette, color, "dark", theme.palette.action.hover),
      },
    }),
  };

  switch (variant) {
    case "elevated":
      return {
        ...commonStyle,
        "&.Mui-disabled": {
          background: "white",
          boxShadow:
            "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);",
        },
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);",
      };
    case "filled-disabled":
      return {
        ...commonStyle,
        backgroundColor: `${getColor(theme.palette, color, "main", "white")} !important`,
      };
    case "filled":
      return {
        ...commonStyle,
        color: "white",
      };
    case "border":
      return {
        ...commonStyle,
        border: `solid 2px ${theme.palette.primary.main}`,
      };
    case "outlined":
      return {
        ...commonStyle,
        border: `solid 2px ${getColor(theme.palette, color, "main")}`,
        backgroundColor: undefined,
        "&:hover": {},
      };
    default:
      return commonStyle;
  }
});
